/* eslint-disable react/no-array-index-key */
import { HStack, PinInput, PinInputField, PinInputProps, StackProps } from '@chakra-ui/react'
import { useField } from 'formik'

import FormControl, { BaseProps } from '../FormControl'

export type PinInputControlProps = BaseProps & {
  pinAmount: number
  stackProps?: StackProps
  pinInputProps?: Omit<PinInputProps, 'children'>
  success?: boolean
  error?: string
  setValidationCode?: (value: string) => void
}

export const PinInputControl: React.FC<PinInputControlProps> = ({
  name,
  label,
  pinAmount,
  stackProps,
  pinInputProps,
  success,
  error: errorInput,
  setValidationCode,
  ...rest
}) => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [field, { touched }, { setValue, setTouched }] = useField(name)

  const borderColor = success
    ? 'green.300'
    : errorInput
    ? 'red.300'
    : 'gray.200'

  const handleChange = (value: string) => {
    if (setValidationCode) setValidationCode(value.toUpperCase())
    setValue(value.toUpperCase())
  }

  return (
    <FormControl
      name={name}
      label={label}
      {...rest}
      errorMessageProps={{ justifyContent: 'center', alignItems: 'center' }}
    >
      <HStack {...stackProps} justifyContent="center" alignItems="center">
        <PinInput
          {...field}
          onChange={handleChange}
          {...pinInputProps}
          focusBorderColor="transparent"
        >
          {Array.from({ length: pinAmount }, (_, index) => (
            <PinInputField
              key={index}
              borderColor={borderColor}
              _focus={{
                borderColor,
                boxShadow: `0 0 0 1px ${borderColor}`,
              }}
              _hover={{
                borderColor,
              }}
            />
          ))}
        </PinInput>
      </HStack>
    </FormControl>
  )
}

export default PinInputControl
